import dayjs from "dayjs";
import {
  isStrictDisplayDateString,
  parseStrictDisplayDate,
} from "utils/helpers/date";

export const PPE_QUESTION =
  "Exercez-vous ou avez-vous exercé depuis moins d'un an une fonction politique, juridictionnelle ou administrative importante en France ou à l'étranger (vous-même ou un proche, conjoint, enfant) ?";

export const shouldShowPpeDetails = (isPep) => isPep === true;

/** First explicit Oui/Non wins; unanswered stays empty. */
export const resolveIsPep = (...values) => {
  const explicit = values.find((value) => value === true || value === false);
  return explicit ?? null;
};

export const clearPpeDetails = () => ({
  ppeFunction: "",
  ppeStartDate: null,
  ppeEndDate: null,
});

const toPpeDay = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "string" && isStrictDisplayDateString(value)) {
    return parseStrictDisplayDate(value);
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

export const isPpeEndDateBeforeStart = (startDate, endDate) => {
  const start = toPpeDay(startDate);
  const end = toPpeDay(endDate);
  if (!start || !end) return false;
  return end.isBefore(start, "day");
};

export const validatePpeDeclaration = ({
  isPep,
  ppeFunction,
  ppeStartDate,
  ppeEndDate,
}) => {
  if (isPep !== true && isPep !== false) {
    return { valid: false, field: "isPep" };
  }
  if (isPep === true) {
    if (!ppeFunction || !String(ppeFunction).trim()) {
      return { valid: false, field: "ppeFunction" };
    }
    if (!ppeStartDate) {
      return { valid: false, field: "ppeStartDate" };
    }
    if (isPpeEndDateBeforeStart(ppeStartDate, ppeEndDate)) {
      return { valid: false, field: "ppeEndDate" };
    }
  }
  return { valid: true };
};
